/**
 * Inches / centimetres toggle.
 *
 * Converts in the browser from the inch values already in the table rather than
 * storing two sets of measurements. One source of numbers means the cm column
 * can never drift from the inch column, which is exactly what happens when a
 * merchant updates one and forgets the other.
 */
class SizeChart extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('[data-unit-button]'));
    this.cells = Array.from(this.querySelectorAll('[data-measure]'));
    this.baseUnit = this.dataset.baseUnit === 'cm' ? 'cm' : 'in';

    this.cells.forEach((cell) => {
      cell.dataset.base = cell.textContent.trim();
    });

    this.buttons.forEach((button) =>
      button.addEventListener('click', () => this.setUnit(button.dataset.unitButton))
    );
  }

  setUnit(unit) {
    this.buttons.forEach((button) =>
      button.setAttribute('aria-pressed', String(button.dataset.unitButton === unit))
    );

    this.cells.forEach((cell) => {
      const base = parseFloat(cell.dataset.base);
      if (Number.isNaN(base)) return; // Non-numeric cells pass through untouched.

      if (unit === this.baseUnit) {
        cell.textContent = cell.dataset.base;
      } else if (unit === 'cm') {
        cell.textContent = (base * 2.54).toFixed(1);
      } else {
        cell.textContent = (base / 2.54).toFixed(1);
      }
    });
  }
}

if (!customElements.get('size-chart')) {
  customElements.define('size-chart', SizeChart);
}
